// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__nlDld","downloadCV":"Footer_downloadCV__+FafE"};